<template>
  <div class="h-screen flex w-full bg-img">
    <div class="vx-col w-4/5 sm:w-4/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="w-full flex flex-row">
            <div class="hidden lg:block lg:w-1/2 mx-auto self-center">
              <img src="@/assets/images/pages/forgot-password.png" alt="login" class="mx-auto">
            </div>
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg">
              <div class="p-8">
                <div class="vx-card__title mb-8">
                  <h4 class="mb-4">{{ $t('pages.login.forgotPassword.title') }}</h4>
                  <p v-if="!successMessage">{{ $t('pages.login.forgotPassword.subtitle') }}</p>
                </div>

                <validation-observer ref="loginForm" v-slot="{ failed }">
                  <validation-provider vid="email" name="email" rules="required|email" v-slot="{ errors, validate, failed }" v-if="!successMessage">
                    <div>
                      <vs-input type="text" icon-no-border icon="icon icon-user" icon-pack="feather"
                                :label-placeholder="$t('fields.email')" @input="validate" :danger="failed"
                                v-model.trim="recoveryEmail" class="w-full"/>
                      <bds-error :text_error="errors[0]"/>
                    </div>
                  </validation-provider>
                  <div v-else>
                    <span class="text-xl text-primary">{{ successMessage }}</span>
                  </div>

                  <div class="w-full flex justify-end py-2 space-x-2">
                    <vs-button type="border" color="warning" :to="{ name: 'login' }">
                      {{ $t('pages.login.forgotPassword.login') }}
                    </vs-button>

                    <vs-button @click="submitRecovery" v-if="!successMessage"
                               :disabled="failed">
                      {{ $t('pages.login.forgotPassword.recoveryPassword') }}
                    </vs-button>
                  </div>
                </validation-observer>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import AuthService from "@/services/Auth.service";

export default {
  components: {
    ValidationProvider,
    ValidationObserver
  },
  data () {
    return {
      recoveryEmail: '',
      successMessage: null
    }
  },
  computed: {

  },
  methods: {
    submitRecovery () {
      const payload = {
        email: this.recoveryEmail
      };

      return AuthService.forgotPassword(payload).then(() => {
        this.successMessage = this.$t('pages.login.forgotPassword.successSubmit');
      }, error => {
        this.$refs.loginForm.setErrors({
          email: error.message,
        });
      });
    }
  },
  mounted() {

  }
}
</script>


<style scoped>

</style>
